import { createContext } from 'react';

import { OptionsObject, SnackbarMessage, VariantType } from 'notistack';

export interface SnackbarContext {
  openSnackbar: (message: SnackbarMessage, variant: VariantType, options?: OptionsObject) => void;
}

export default createContext<SnackbarContext | null>(null);
